<section class="qa-history-tab">
  <app-qa-history [showOneOrderOnly]="false" [enableCreateNC]="true"></app-qa-history>
</section>
